// extracted by mini-css-extract-plugin
export var formContainer = "_jt-0";
export var message = "_jt-1";